import React, { Component } from 'react'
import { Accordion, Icon } from 'semantic-ui-react'
import './styles.scss'

export default class PrivacyPolicy extends Component {
  state = { activeIndex: 0 }

  handleClick = (e, titleProps) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    const newIndex = activeIndex === index ? -1 : index

    this.setState({ activeIndex: newIndex })
  }

  render() {
    const { activeIndex } = this.state

    return (
      <div className='privacy-policy'>
        <Accordion fluid styled>
          <Accordion.Title
            active={activeIndex === 0}
            index={0}
            onClick={this.handleClick}
          >
            <Icon name='dropdown' />
            Erhebung von Daten
          </Accordion.Title>
          <Accordion.Content active={activeIndex === 0}>
            <p>Wir erheben und speichern die folgenden Daten:</p>
            <ul>
              <li>Ihre Top-100-Songs von Ihrem Spotify-Account</li>
              <li>
                Die Mittelwerte der oben genannten Musikattribute Ihrer
                Top-100-Songs
              </li>
              <li>Ihr auf Spotify hinterlegtes Alter</li>
            </ul>
            <p>
              Wir verwenden die so gespeicherten Daten ausschliesslich für die
              Auswertung und Visualisierung im Rahmen dieses Artikels sowie für
              einen möglichen Folgeartikel.
            </p>
            <p>
              Alle Daten, welche so verwendet werden, sind anonym und werden
              nicht persönlichen Daten zugeordnet (z.B. indem die Daten mit
              Konten, Cookies, IP-Adressen oder Ähnlichem kombiniert werden).
            </p>
          </Accordion.Content>

          <Accordion.Title
            active={activeIndex === 1}
            index={1}
            onClick={this.handleClick}
          >
            <Icon name='dropdown' />
            Google Analytics
          </Accordion.Title>
          <Accordion.Content active={activeIndex === 1}>
            <p>
              Für die Benutzerstatistik wird die Software Google Analytics
              eingesetzt. Eine Verknüpfung der dort erhobenen Daten mit
              anderweitig erhobenen (einschliesslich der oben aufgeführten)
              Daten ist ausgeschlossen. Die Verwendung von Google Analytics in
              der Tamedia-Musikgeschmack-Analyse entspricht derjenigen in den
              Newsportalen der Tamedia-Gruppe. Weitere Informationen dazu finden
              Sie in der{' '}
              <a href='https://abo.tagesanzeiger.ch/tamstorefront/terms/register'>
                Datenschutzerklärung
              </a>{' '}
              von Tamedia.
            </p>
          </Accordion.Content>
        </Accordion>
      </div>
    )
  }
}
